import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { vuetify } from './plugins/vuetify'
import { primeAntiforgeryToken, setBuildVersionHandler } from './api/client'
import { useAppStore } from './stores/app'
import { registerServiceWorker, watchForInstallOffer } from './pwa'
import './assets/base.css'

const pinia = createPinia()

// Every API answer reports the build that produced it, and the store decides
// whether that means this client is behind (SPEC §13.1, MT-112). Wired before
// mounting, because mounting starts the first navigation and the household
// guard's request is the first answer worth reading.
const app = useAppStore(pinia)
setBuildVersionHandler((version) => app.noteServerVersion(version))

createApp(App).use(pinia).use(router).use(vuetify).mount('#app')

// Before registration, and before anything could ask: the browser fires its
// install offer once, early, and an offer nobody was listening for is gone.
watchForInstallOffer()
registerServiceWorker((waiting) => app.noteWorkerWaiting(waiting))

// Fetch the anti-forgery token during bootstrap (SPEC §14.8) so the first
// action a person takes does not wait on a round trip of its own. Deliberately
// not awaited before mounting: a slow or failed token fetch must not hold up
// rendering, and the client fetches one on demand if this has not landed.
void primeAntiforgeryToken()
